import React from 'react';
import { useSelector } from 'react-redux';
import { Navigator } from '../../navigation/components/Navigator';
import { StripContent } from '../../plot/components/StripContent';
import { STRIP_EDITOR_WIDTH } from '../../plot/components/StripEditor';
import { THREE_LEAD_DURATION } from '../../plot/components/ThreeLeadPlot';
import { Column } from '../../plot/contexts/column.context';
import { Plot } from '../../plot/contexts/plot.context';
import { Row } from '../../plot/contexts/row.context';
import { Strip } from '../../plot/contexts/strip.context';
import { useScale } from '../../plot/hooks/useScale';
import {
  STRIP_WIDTH,
  TOP_PLOT_FOOTER_HEIGHT,
  TOP_PLOT_HEADER_HEIGHT,
  TOP_PLOT_HEIGHT,
} from '../../plot/utils/graph.utils';
import { EpisodeMeasurement } from '../../episodeMeasurement/components/EpisodeMeasurement';
import { MAX_BPM } from '../../utils/time';
import {
  allowNavigatorSelector,
  cursorSelector,
  scatterPlotDurationSelector,
  stripOffsetSelector,
  stripStartSelector,
} from '../selectors/scatter.selectors';
import { ScatterBottomAxis } from './ScatterBottomAxis';
import { ScatterGraph } from './ScatterGraph';
import { ScatterLeftAxis } from './ScatterLeftAxis';
import { EpisodeMeasurementContainer } from '../../episodeMeasurement/components/EpisodeMeasurementContainer';
import { PlotContainer } from '../../plot/components/PlotContainer';

const SCATTER_PLOT_SIZE = TOP_PLOT_HEIGHT;

export const ScatterPlot: React.FC = () => {
  const stripStart = useSelector(stripStartSelector);
  const stripDuration = useSelector(scatterPlotDurationSelector);
  const allowNavigator = useSelector(allowNavigatorSelector);
  const offset = useSelector(stripOffsetSelector);
  const cursor = useSelector(cursorSelector);

  const bpmScale = useScale({
    domain: { start: MAX_BPM, end: 0 },
    range: { end: SCATTER_PLOT_SIZE },
  });

  return (
    <PlotContainer style={{ cursor }} data-testid='scatter-plot'>
      <Strip id='scatter-plot' duration={stripDuration} durationOffset={offset}>
        <Plot>
          <Row height={SCATTER_PLOT_SIZE} topOffset={TOP_PLOT_HEADER_HEIGHT}>
            <Column width={STRIP_EDITOR_WIDTH}>
              <ScatterLeftAxis yScale={bpmScale} />
            </Column>
            <Column width={STRIP_WIDTH}>
              {allowNavigator && (
                <Navigator durations={[THREE_LEAD_DURATION]} />
              )}
              <StripContent clipType='vertical' data-testid='strip-content'>
                <EpisodeMeasurementContainer>
                  <EpisodeMeasurement />
                </EpisodeMeasurementContainer>
              </StripContent>
              <ScatterGraph stripStart={stripStart} yScale={bpmScale} />
            </Column>
          </Row>
          <Row height={TOP_PLOT_FOOTER_HEIGHT}>
            <Column width={STRIP_EDITOR_WIDTH} />
            <Column width={STRIP_WIDTH}>
              <ScatterBottomAxis />
            </Column>
          </Row>
        </Plot>
      </Strip>
    </PlotContainer>
  );
};
